export function createServiceFormValidator(values) {
  const errors: any = {};

  if (!values.category) errors.category = "Category field is required";

  if (!values.title) errors.title = "Title field is required";

  if (!values.description) errors.description = "Description field is required";

  if (!values.link) errors.link = "Link field is required";

  return errors;
}
